import React, { useEffect, useState } from 'react';
import MediaQuery, { useMediaQuery } from 'react-responsive';

// DS
import {
  Row,
  VertBreadcrumb,
  VertContainer,
  VertIcon,
} from '@vertem-core/vertice-ds';

// COMPONENTS
import { SearchSidebar, SearchTopbar } from 'components/SearchSidebar';
import CategoryChipsMenu from 'components/CategoryChipsMenu/CategoryChipsMenu';
import Pagination from 'components/Pagination/Pagination';
import SearchFilter from 'components/SearchSidebar/SearchFilters';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RightOutlined } from '@ant-design/icons';
import CategoryItems from './CategoryItems';
import CategoryWrapper from './CategoryWrapper';
import CreateFiltersParams from '../../Utils/createFiltersParams';
import { useCategoryPage } from './CategoryPageProvider';
import usePipeContext from '../../Services/Providers/PipeProvider/usePipeContext';
import CreateSearchHash from '../../Utils/createSearchHash';
import FormatProductsItems from '../../Utils/formatProductsItems';
import CategoryPagePlaceholder from './CategoryPagePlaceholder';
import SelectOrderBy from '../../components/SelectOrderBy/SelectOrderBy';
import ynToBool from 'Utils/ynToBool';

const breadcrumbMock = [
  {
    title: 'Início',
    path: '/',
  },
  {
    title: 'Categorias',
    path: '/category',
  },
];
// CATEGORY PAGE
const CategoryPage = () => {
  const [currentPage, setCurrentPage] = useState(null);
  const Search = useSelector(({ Search: data }) => data);
  const Navigate = useNavigate();
  const {
    filter: filterObject,
    setFilter,
    title,
    filterString,
  } = useCategoryPage();
  const { callApiForce } = usePipeContext();
  const [searchSidebarVisible, setSearchSidebarVisible] = useState(false);
  const { id: categoryId, pagenumber, filter: filterParam } = useParams();
  const isLargeScreen = useMediaQuery({ minWidth: 769 });

  /* Vars */
  const wrapperGutterValue = isLargeScreen ? 20 : 0;

  const handleSetFilter = (fParam) => {
    setFilter(
      CreateFiltersParams(
        {
          categories: categoryId,
          pageIndex: parseInt(pagenumber, 10) - 1,
        },
        fParam
      ),
      fParam
    );
    setCurrentPage(pagenumber);
  };

  useEffect(() => {
    if (
      categoryId &&
      pagenumber &&
      (!filterObject ||
        filterObject.categories !== categoryId ||
        (filterParam && filterParam !== filterString) ||
        (!filterParam && filterString && filterString !== 'e30=') ||
        pagenumber !== currentPage)
    ) {
      let f = filterParam || 'e30=';
      if (filterString && !filterParam) f = false;
      handleSetFilter(f);
    }
  }, [
    categoryId,
    pagenumber,
    filterParam,
    setFilter,
    filterObject,
    filterString,
    currentPage,
  ]);

  useEffect(() => {
    if (filterObject && callApiForce) {
      callApiForce(
        {
          symbol: 'FETCH_SEARCH',
          alias: null,
          payload: { filters: { ...filterObject } },
        },
        new Date().getTime()
      );
    }
  }, [filterObject, callApiForce]);

  return (
    <>
      <VertContainer
        className="vert-container-page"
        spacingX="regular"
        spacingY="regular"
      >
        <VertBreadcrumb hasBackButton={true}
          separator={<VertIcon component={RightOutlined} />}
          items={breadcrumbMock}
        />
      </VertContainer>
      <MediaQuery minWidth={769}>
        { ynToBool(process.env.REACT_APP_SHOW_CATEGORIES_CARROUSEL) && (<>
          <CategoryChipsMenu />
        </>)}
      </MediaQuery>
      {(() => {
        if (!Search || Search.isLoading) return <CategoryPagePlaceholder />;
        return (
          <VertContainer
            className="vert-container-page"
            spacingX="regular"
            spacingY="regular"
          >
            <MediaQuery maxWidth={768}>
              <SelectOrderBy
                searchSidebarVisible={searchSidebarVisible}
                toggleSearchSidebar={setSearchSidebarVisible}
                valueSort={
                  (filterObject &&
                    filterObject.sort !== 'SCORE' &&
                    filterObject.sort) ||
                  ''
                }
                onChange={(e) => {
                  if (e !== 'SCORE') {
                    const searchString = CreateSearchHash(filterObject, {
                      sort: e,
                    });
                    Navigate(
                      `/category/${categoryId}/1/filter/${searchString}`
                    );
                  } else {
                    const searchString = CreateSearchHash(filterObject, {});
                    handleSetFilter(null);
                    setTimeout(() => {
                      if (searchString) {
                        Navigate(
                          `/category/${categoryId}/1/filter/${searchString}`
                        );
                      } else {
                        Navigate(`/category/${categoryId}/1`);
                      }
                    }, 500);
                  }
                }}
              />
            </MediaQuery>
            <SearchTopbar
              title={title}
              value={
                (filterObject &&
                  filterObject.sort !== 'SCORE' &&
                  filterObject.sort) ||
                ''
              }
              onChange={(e) => {
                if (e !== 'SCORE') {
                  const searchString = CreateSearchHash(filterObject, {
                    sort: e,
                  });
                  Navigate(`/category/${categoryId}/1/filter/${searchString}`);
                } else {
                  const searchString = CreateSearchHash(filterObject, {});
                  handleSetFilter(null);
                  setTimeout(() => {
                    if (searchString) {
                      Navigate(
                        `/category/${categoryId}/1/filter/${searchString}`
                      );
                    } else {
                      Navigate(`/category/${categoryId}/1`);
                    }
                  }, 500);
                }
              }}
            />
            <Row gutter={wrapperGutterValue}>
              <SearchSidebar
                searchSidebarVisible={searchSidebarVisible}
                toggleSearchSidebar={setSearchSidebarVisible}
              >
                <MediaQuery maxWidth={768}>
                  <SearchFilter
                    filters={filterObject}
                    filterParams={filterParam}
                    clearFilters={() => {
                      Navigate(`/category/${categoryId}/1`);
                    }}
                    onSubmit={(hash) => {
                      if (hash) {
                        Navigate(`/category/${categoryId}/1/filter/${hash}`);
                      } else {
                        Navigate(`/category/${categoryId}/1`);
                      }
                    }}
                  />
                </MediaQuery>
                <MediaQuery minWidth={769}>
                  {(() => {
                    if (!Search || Search.isLoading) {
                      return null;
                    }
                    return (
                      <SearchFilter
                        className="padding-x-small padding-y-small"
                        filters={filterObject}
                        filterParams={filterParam}
                        clearFilters={() => {
                          Navigate(`/category/${categoryId}/1`);
                        }}
                        onSubmit={(hash) => {
                          if (hash) {
                            Navigate(
                              `/category/${categoryId}/1/filter/${hash}`
                            );
                          } else {
                            Navigate(`/category/${categoryId}/1`);
                          }
                        }}
                      />
                    );
                  })()}
                </MediaQuery>
              </SearchSidebar>
              <CategoryWrapper>
                {(() => {
                  if (Search.isLoading || !Search.data) return null;
                  return (
                    <CategoryItems
                      items={FormatProductsItems(Search.data.products) || []}
                    />
                  );
                })()}
              </CategoryWrapper>
            </Row>
            {(() => {
              if (Search.isLoading || !Search.data) return null;
              return (
                <Pagination
                  current={parseInt(pagenumber, 10)}
                  total={Search.data.totalRowCount}
                  pageSize={12}
                  callback={(page) => {
                    if (filterParam) {
                      Navigate(
                        `/category/${categoryId}/${page}/filter/${filterParam}`
                      );
                    } else {
                      Navigate(`/category/${categoryId}/${page}`);
                    }
                  }}
                />
              );
            })()}
          </VertContainer>
        );
      })()}
    </>
  );
};

export default CategoryPage;
